import {
  getBlockView,
  useTypedSelector,
} from '@plone-collective/volto-editortemplates/helpers/helpers';
import { useEffect } from 'react';
import {
  BlockTemplatesProvider,
  useBlockTemplates,
} from '@plone-collective/volto-editortemplates/components/Providers/block-template-editor';
import type { BlockTemplatesState } from '@plone-collective/volto-editortemplates/reducers/blocks-reducers';
import { defineMessages, useIntl } from 'react-intl';
import type { BlockViewProps } from '@plone/types';
import type {
  BlockTemplateData,
  TemplateData,
} from '@plone-collective/volto-editortemplates/types';
import StyleWrapper from '@plone/volto/components/manage/Blocks/Block/StyleWrapper';

type BlockTemplateErrorMessages =
  | 'VOLTO_EDITOR_TEMPLATES_NO_TEMPLATE'
  | 'VOLTO_EDITOR_TEMPLATES_INVALID';

const messages = defineMessages({
  VOLTO_EDITOR_TEMPLATES_NO_TEMPLATE: {
    id: 'VOLTO_EDITOR_TEMPLATES_NO_TEMPLATE',
    defaultMessage:
      'Template not found. It was probably deleted, please remove this block.',
  },
  VOLTO_EDITOR_TEMPLATES_INVALID: {
    id: 'VOLTO_EDITOR_TEMPLATES_INVALID',
    defaultMessage:
      'Template not found, block malformed. Please remove this block.',
  },
});

interface TemplateSelectorBlockViewProps extends BlockViewProps {
  data: BlockTemplateData<TemplateData>;
  isEditMode: boolean;
}

const ViewBlock = (props: TemplateSelectorBlockViewProps) => {
  const { data, isEditMode } = props;
  const intl = useIntl();
  const { getBlockByUID } = useBlockTemplates();
  const blockTemplate = useTypedSelector<BlockTemplatesState>(
    (state) => state.blocksTemplates?.subrequests?.[props.data.uid],
  );
  useEffect(() => {
    if (isEditMode) getBlockByUID(data.uid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if ((!blockTemplate && isEditMode) || !data) return null;
  const templateConfig = isEditMode
    ? Object.values(blockTemplate?.templates?.[0]?.config ?? {})[0] ?? {}
    : Object.values(data?.config)?.[0] ?? {};

  const templateBlockType: string = templateConfig?.['@type'];
  if (data.error) {
    return isEditMode ? (
      <div>{intl.formatMessage(messages[data.error.code])}</div>
    ) : null;
  }
  if (!templateBlockType) return null;
  const block = { ...props, data: templateConfig };

  const BlockView = getBlockView(templateBlockType);
  return (
    <StyleWrapper data={templateConfig} block={props.id}>
      <BlockView {...block} key={block.id} />
    </StyleWrapper>
  );
};
const View = (props: TemplateSelectorBlockViewProps) => {
  return (
    <BlockTemplatesProvider isEditMode={false}>
      <ViewBlock {...props} />
    </BlockTemplatesProvider>
  );
};
export { View, ViewBlock, type BlockTemplateErrorMessages };
